import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Bonusissues.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../../utils/useLocalStorage";
import CorporateActOption from "../../CorporateActOption/CorporateActOption";
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function Bonusissues() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        window.scrollTo(0, 0)
        // if (groupValue === "a-z") {
        const getUrl = BaseURL + "CorporateAction";
        fetch(`${getUrl}/bonus/-/-/-/10`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });


        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, []);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("Bonus",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Bonus</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Bonissu-loser-sc'>
                            <div className='Bonissu-header'>
                                <h2><span>Bonus Issues</span></h2>
                            </div>
                            <CorporateActOption optionCorp="Bonus" />
                            <div className='Bonissu-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-center'>Ratio</th>
                                            <th className='text-center'>Record Date</th>
                                            <th className='text-center'>Ex Date</th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ co_name, BonusRatio, RecordDate, BonusDate, co_code }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={routeChange} data-id={co_name + '-' + co_code}>{co_name}</h6></td>

                                                    <td className="text-center">{BonusRatio}</td>
                                                    <td className="text-center"> {(RecordDate != null) ? RecordDate.split('T')[0] : 0}</td>
                                                    <td className="text-center"> {(BonusDate != null) ? BonusDate.split('T')[0] : 0}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Bonusissues;